import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard, RoleGuard, DefaultRouteGuard } from '@app/shared';
import { NoAccessComponent } from './commons/no-access/no-access.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'resetpassword',
   // path: 'resetpassword/:token /:email /:loginid',
    component: ResetPasswordComponent
  },
  {
    path: 'updatepassword',
    component: UpdatePasswordComponent
  },
  {
    path: 'archive',
    component: LoginComponent
  },
  {
    path: '',
    component: HomeComponent,
    canActivateChild: [AuthGuard, RoleGuard],
    children: [
      {
        path: 'calendar',
        loadChildren: () => import('./home/calendar/calendar.module').then(m => m.LlwrCalendarModule),
        // loadChildren: './home/calendar/calendar.module#LlwrCalendarModule'
      },
      {
        path: 'inventory',
        loadChildren: () => import('./home/inventory/inventory.module').then(m => m.InventoryModule),
        // loadChildren: './home/inventory/inventory.module#InventoryModule'
      },
      {
        path: 'master',
        loadChildren: () => import('./home/master/master.module').then(m => m.MasterModule),
        // loadChildren: './home/master/master.module#MasterModule'
      },
      {
        path: 'packaging',
        // loadChildren: './home/packaging/packaging.module#PackagingModule'
        loadChildren: () => import('./home/packaging/packaging.module').then(m => m.PackagingModule),
      },
      {
        path: 'packagingReport',
        loadChildren: () => import('./home/packaging-report/packaging-report.module').then(m => m.PackagingReportModule),
        // loadChildren:
          // './home/packaging-report/packaging-report.module#PackagingReportModule'
      },
      {
        path: 'transaction',
        loadChildren: () => import('./home/transaction/transaction.module').then(m => m.TransactionModule),
        // loadChildren: './home/transaction/transaction.module#TransactionModule'
      },
      {
        path: 'transport',
        loadChildren: () => import('./home/transport/transport.module').then(m => m.TransportModule),
        // loadChildren: './home/transport/transport.module#TransportModule'
      },
      {
        path: 'transportReport',
        loadChildren: () => import('./home/transport-report/transport-report.module').then(m => m.TransportReportModule),
        // loadChildren:
          // './home/transport-report/transport-report.module#TransportReportModule'
      },
      {
        path: 'manufacturerReport',
        loadChildren: () => import('./home/manufacturer-reports/manufacturer-reports.module').then(m => m.ManufacturerReportsModule),

        // loadChildren:
          // './home/manufacturer-reports/manufacturer-reports.module#ManufacturerReportsModule'
      },
      {
        path: 'accessDenied',
        component: NoAccessComponent
      },
      {
        path: '',
        redirectTo: 'transaction',
        canActivate: [DefaultRouteGuard],
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)]
})
export class AppRoutingModule { }

export const AppRoutedComponents = [HomeComponent, LoginComponent, ResetPasswordComponent, UpdatePasswordComponent];
